import { IonItem, IonLabel, IonNote } from '@ionic/react';
import React from 'react';
import { Case } from '../../../services/buildfire/rdb/cases';
import * as RDBCases from '../../../services/buildfire/rdb/cases';
import { formatAge } from '../../../util/age';
import { useHistory } from 'react-router-dom';

interface PatientInfoProps {
  case: Case;
}

const PatientInfo: React.FC<PatientInfoProps> = ({ case: c }) => {
  const history = useHistory();

  return (
    <IonItem
      button
      detail
      id="case-info_patient-info"
      onClick={(e) => {
        history.push(`${c.id}/edit-patient`, { from: 'caseInfo' });
      }}
    >
      <IonLabel>
        Patient Info
        {c.internalReferenceNumber
          ? ` (ref. ${c.internalReferenceNumber})`
          : ''}
        <br />
        <IonNote>
          {c.patient.first} {c.patient.last} · {RDBCases.SpeciesMap[c.species]}{' '}
          · {formatAge(c.age, c.ageMonths)}
        </IonNote>
      </IonLabel>
    </IonItem>
  );
};

export default PatientInfo;
